import React from "react";
import { Link } from "react-router-dom";
import "./Privacy.scss";

export default function Privacy() {
  return (
    <>
      <div className="hea">
        <Link to="/" style={{ textDecoration: "none", color: "black" }}>
          <h1 style={{ cursor: "pointer" }}>Gasport</h1>
        </Link>
        {/* <Link to="/newsfeed" style={{ textDecoration: "none", color: "black" }}>
          <h1 style={{ cursor: "pointer" }}>Newsfeed</h1>
        </Link> */}
      </div>
      <div className="privacy">
        <div className="modal-content">
          <h2>Privacy Policy</h2>
          <p>
            Gasports ("We") are committed to protecting and respecting your
            privacy.
            <br />
            <br />
            This policy (together with our terms of use and any other documents
            referred to on it) sets out the basis on which any personal data we
            collect from you, or that you provide to us, will be processed by
            us. Please read the following carefully to understand our views and
            practices regarding your personal data and how we will treat it. By
            visiting www.mrparts.ng you are accepting and consenting to the
            practices described in this policy.
            <br />
            <br />
            <b>SECTION 1 - WHAT WE COLLECT </b>
            <br />
            <br />
            This includes information provided at the time of registering to use
            our site, subscribing to our service, purchasing goods, posting
            material or requesting further services. We may also ask you for
            information when you report a problem with our site.
            <br />
            <br />
            <b>SECTION 2 - WHAT WE DO WITH YOUR INFORMATION</b>
            <br />
            <br />
            We require this information to understand your needs and provide you
            with a better service, and in particular for the following reasons:
            <br />
            <b>
              <u>Internal Record Keeping</u>
            </b>
            <br />
            We may use the information to improve our products and services. We
            may periodically send promotional emails about new products, special
            offers or other information which we think you may find interesting
            using the email address which you have provided. We may contact you
            by email. From time to time, we may also use your information to
            contact you for market research purposes. We may use the information
            to customize the website according to your interests.
            <br />
            <b>
              <u>Security</u>
            </b>
            <br />
            To protect your personal information, we take reasonable precautions
            and follow industry best practices to make sure it is not
            inappropriately lost, misused, accessed, disclosed, altered or
            destroyed. If you provide us with your credit card information, the
            information is encrypted using secure socket layer technology (SSL)
            and stored with a AES-256 encryption. Although no method of
            transmission over the Internet or electronic storage is 100% secure,
            we follow all PCI-DSS requirements and implement additional
            generally accepted industry standards.
            <br />
            <br />
            <b>SECTION 3 - CONSENT</b>
            <br />
            <br />
            When you provide us with personal information to complete a
            transaction, verify your credit card, place an order, arrange for a
            delivery or return a purchase, we imply that you consent to our
            collecting it and using it for that specific reason only. If we ask
            for your personal information for a secondary reason, like
            marketing, we will either ask you directly for your expressed
            consent, or provide you with an opportunity to say no.
            <br />
            <br />
            <b>SECTION 4 - IP ADDRESSES AND COOKIES</b>
            <br />
            <br />
            We may collect information about your computer, including where
            available your IP address, operating system and browser type, for
            system administration and to report aggregate information to our
            advertisers. This is statistical data about our users' browsing
            actions and patterns, and does not identify any individual For the
            same reason, we may obtain information about your general internet
            usage by using a cookie file which is stored on the hard drive of
            your computer. Cookies contain information that is transferred to
            your computer's hard drive. They help us to improve our site and to
            deliver a better and more personalized service. They enable us to
            estimate our audience size and usage pattern, to speed up your
            searches, to recognize you when you return to our site, to store
            information about your preferences, and so allow us to customize our
            site according to your individual interests. Mr Parts website saves
            the contents of your basket when you haven’t completed a
            transaction. If you quit the Mr Parts website without placing an
            order the system will remember the items you added to your basket
            and send you an email with a reminder. We do this to make sure your
            shopping experience is as hassle free as possible. If you do not
            want to receive these emails in the future, please click on the
            unsubscribe link at the bottom of the email you have received.
            <br />
            <br />
            <b>SECTION 5 - LINKS TO OTHER WEBSITES AND THIRD PARTIES</b>
            <br />
            <br />
            Our website may contain links to other websites of interest.
            However, once you have used these links to leave our site, you
            should note that we do not have any control over that other website.
            Therefore, we cannot be responsible for the protection and privacy
            of any information which you provide whilst visiting such sites and
            such sites are not governed by this privacy statement. You should
            exercise caution and look at the privacy statement applicable to the
            website in question. We may disclose your personal information to
            third parties: If we are under a duty to disclose or share your
            personal data in order to comply with any legal obligation, or in
            order to enforce or apply our terms of use or terms and conditions
            of supply and other agreements; or to protect the rights, property,
            or safety of Auto Surgeons Limited, our customers, or others. This
            includes exchanging information with other companies and
            organisations for the purposes of fraud protection and credit risk
            reduction.
            <br />
            <br />
            <b>SECTION 6 - YOUR RIGHTS</b>
            <br />
            <br />
            You may choose to restrict the collection or use of your personal
            information in the following ways: whenever you are asked to fill in
            a form on the website, look for the box that you can click to
            indicate that you do not want the information to be used by anybody
            for direct marketing purposes. If you have previously agreed to us
            using your personal information for direct marketing purposes, you
            may change your mind at any time by writing to or emailing us at
            support@mrparts.ng We will not sell, distribute or lease your
            personal information to third parties unless we have your permission
            or are required by law to do so. If you believe that any information
            we are holding on you is incorrect or incomplete, please write to or
            email us as soon as possible, at the above address. We will promptly
            correct any information found to be incorrect
            <br />
            <br />
            <b>SECTION 7 - AGE OF CONSENT</b>
            <br />
            <br />
            By using this site, you represent that you are at least the age of
            majority in your state or province of residence, or that you are the
            age of majority in your state or province of residence and you have
            given us your consent to allow any of your minor dependents to use
            this site.
            <br />
            <br />
            <b>SECTION 8 - CHANGES TO THIS PRIVACY POLICY </b>
            <br />
            <br />
            We reserve the right to modify this privacy policy at any time, so
            please review it frequently. Changes and clarifications will take
            effect immediately upon their posting on the website. If we make
            material changes to this policy, we will notify you here that it has
            been updated, so that you are aware of what information we collect,
            how we use it, and under what circumstances, if any, we use and/or
            disclose it. If our store is acquired or merged with another
            company, your information may be transferred to the new owners so
            that we may continue to sell products to you.
            <br />
            <br />
            <b>QUESTIONS AND CONTACT INFORMATION</b>
            <br />
            <br />
            If you would like to: access, correct, amend or delete any personal
            information we have about you, register a complaint, or simply want
            more information contact our Privacy Compliance Officer at
            support@gasportlite.com
          </p>
        </div>
      </div>
    </>
  );
}
